import { Header } from "@/components/header";
import { Footer } from "../home/sections/footer";

import SuccessAnimation from "@/assets/lottie/success.json";

import "./styles.scss";
import Lottie from "lottie-react";
import { useRobotsIgnorePage } from "@/hooks/useRobotsIgnorePage";

export const PaymentConfirmed = () => {
  useRobotsIgnorePage();

  return (
    <>
      <div className="payment-confirmed-wrapper">
        <Header />

        <div className="payment-confirmed-infos">
          <Lottie
            animationData={SuccessAnimation}
            loop
            autoPlay
            className="success-animation"
          />
          <h1>Pagamento confirmado!</h1>
          <p>
            Sua assinatura foi confirmada com sucesso. Em breve nossa equipe
            entrará em contato para iniciar a configuração do seu app.
          </p>
          <p>Obrigado por escolher a Provenduz!</p>
        </div>

        <Footer />
      </div>
    </>
  );
};
